import { type ValidatedWizardStepsConfig } from "@krakentech/blueprint-onboarding"
import {
    MeterPowerAnalysisRouteNames,
    meterPowerAnalysisRoutesPaths,
} from "@/routes/meterPowerAnalysis"
import { type MeterPowerAnalysisFormValues } from "../types/meterPowerAnalysisFormValues"

const firstStep = {
    name: MeterPowerAnalysisRouteNames.Landing,
    pathname: meterPowerAnalysisRoutesPaths.landing.resolve(),
    validate: () => true,
}

export const meterPowerAnalysisSteps = [
    firstStep,
    {
        parentName: firstStep.name,
        name: MeterPowerAnalysisRouteNames.Error,
        pathname: meterPowerAnalysisRoutesPaths.error.resolve(),
        validate: ({ formValues }) => !!formValues.errorCode,
    },
    {
        parentName: firstStep.name,
        name: MeterPowerAnalysisRouteNames.Overload,
        pathname: meterPowerAnalysisRoutesPaths.overload.resolve(),
        validate: ({ formValues }) => formValues.errorCode === "OVERLOAD",
    },
    {
        parentName: firstStep.name,
        name: MeterPowerAnalysisRouteNames.Adapted,
        pathname: meterPowerAnalysisRoutesPaths.adapted.resolve(),
        validate: ({ formValues }) => !!formValues.currentSubscribedMaxPower,
    },
    {
        name: MeterPowerAnalysisRouteNames.Results,
        pathname: meterPowerAnalysisRoutesPaths.results.resolve(),
        validate: ({ formValues }) => !!formValues.recommendedSubscribedMaxPower,
    },
] as const satisfies ValidatedWizardStepsConfig<
    MeterPowerAnalysisRouteNames,
    MeterPowerAnalysisFormValues
>
